import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../../../domain/access/BaseAccess';
import AccessContainer from '../../../../access/AccessContainer';
import { RootState } from '../../../../../redux/store';
import { changeConfiguration } from '../../../../../redux/actions/ConfigurationActions';
import RoleHelper from '../../../../../RoleHelper';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';

class DomainConfigurationAccessComponent extends Component<Props, State> {
  render() {
    const {
      configuration: { configuration },
    } = this.props;
    const access: AccessBase = { permission: configuration.permission, collaborators: configuration.collaborators };
    return (
      <div className={'flex w-full h-full'}>
        <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.hasGlobalMenuEdit('CaseConfiguration')} />
      </div>
    );
  }

  private changeAccess = (access: AccessBase) => {
    const {
      changeConfiguration,
      configuration: { configuration },
    } = this.props;
    configuration.permission = access.permission;
    configuration.collaborators = access.collaborators;
    changeConfiguration(configuration);
  };
}

interface Props extends ReduxProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  configuration: state.configuration as ConfigurationState,
});
const mapDispatchToProps = { changeConfiguration };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationAccessComponent);
